<template>
    <div>
        <app-page-header></app-page-header>
        <v-container grid-list-xl style="margin-top:-13px;">
            <!-- kriterij iskanja -->
            <v-layout row wrap fill-height>
                <v-flex xs12 sm12 md12 lg12>
                    <v-card>
                        <v-toolbar
                        card 
                        :color="filterToolbarColor">
                            <v-icon medium>filter_list</v-icon>
                            <v-toolbar-title class="body-2">Kriterij iskanja</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <!--<v-icon medium>undo</v-icon>-->
                            <v-btn icon @click="showDataTableFilters= !showDataTableFilters">
                                <v-icon @click="">{{ showDataTableFilters? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-divider v-show="showDataTableFilters"></v-divider><br v-show="showDataTableFilters">
                        <v-card-text v-show="showDataTableFilters">
                            <v-layout row wrap>
                            <v-flex xs12 sm12 md4>
                                <v-subheader class="">Datumska omejitev (od - do)</v-subheader>
                                <!--<p class="pa-4 text-xs-right">Datumska omejitev</p>-->
                            </v-flex>
                            <v-flex xs12 sm12 md4 lg4>
                                <v-menu
                                    ref="menuPicker1"
                                    :close-on-content-click="false"
                                    v-model="menuPicker1"
                                    :nudge-right="40"
                                    :return-value.sync="startDate"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    min-width="290px"
                                    >
                                    <v-text-field
                                        slot="activator"
                                        v-model="startDateFormatted"
                                        label="Datum od"
                                        prepend-icon="event"
                                        readonly
                                    ></v-text-field>
                                    <v-date-picker @input="startDateMenuSave(startDate)" v-model="startDate" no-title scrollable locale="sl-si">
                                        <v-spacer></v-spacer>
                                        <!--<v-btn flat color="primary" @click="menuPicker1 = false">Prekliči</v-btn>
                                        <v-btn flat color="primary" @click="$refs.menuPicker1.save(startDate)">Potrdi</v-btn>-->
                                    </v-date-picker>
                                </v-menu>
                            </v-flex>
                            <v-flex xs12 sm12 md4 lg4>
                                <v-menu
                                    ref="menuPicker2"
                                    :close-on-content-click="false"
                                    v-model="menuPicker2"
                                    :nudge-right="40"
                                    :return-value.sync="endDate"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    min-width="290px"
                                    >
                                    <v-text-field
                                        slot="activator"
                                        v-model="endDateFormatted"
                                        label="Datum do"
                                        prepend-icon="event"
                                        readonly
                                    ></v-text-field>
                                    <v-date-picker @input="endDateMenuSave(endDate)" v-model="endDate" no-title scrollable locale="sl-si">
                                        <v-spacer></v-spacer>
                                        <!--<v-btn flat color="primary" @click="menuPicker2 = false">Prekliči</v-btn>
                                        <v-btn flat color="primary" @click="$refs.menuPicker2.save(endDate)">Potrdi</v-btn>-->
                                    </v-date-picker>
                                </v-menu>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                                <v-flex xs12 sm12 md4 lg4>
                                    <v-subheader>Časovna omejitev (od - do)</v-subheader>
                                    <!--<p class="pa-4 text-xs-right">Časovna omejitev (od - do)</p>-->
                                </v-flex>
                                <v-flex xs12 sm12 md4 lg4>
                                    <v-menu
                                        ref="menuPicker3"
                                        :close-on-content-click="false"
                                        v-model="menuPicker3"
                                        :nudge-right="40"
                                        :return-value.sync="startTime"
                                        lazy
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        max-width="290px"
                                        min-width="290px"
                                        >
                                        <v-text-field
                                            slot="activator"
                                            v-model="startTime"
                                            label="Začetek"
                                            prepend-icon="access_time"
                                            readonly
                                        ></v-text-field>
                                        <v-time-picker
                                            v-if="menuPicker3"
                                            format="24hr"
                                            v-model="startTime"
                                            @change="$refs.menuPicker3.save(startTime)"
                                        ></v-time-picker>
                                    </v-menu>
                                </v-flex>
                                <v-flex xs12 sm12 md4 lg4>
                                    <v-menu
                                        ref="menuPicker4"
                                        :close-on-content-click="false"
                                        v-model="menuPicker4"
                                        :nudge-right="40"
                                        :return-value.sync="endTime"
                                        lazy
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        max-width="290px"
                                        min-width="290px"
                                        >
                                        <v-text-field
                                            slot="activator"
                                            v-model="endTime"
                                            label="Konec"
                                            prepend-icon="access_time"
                                            readonly
                                        ></v-text-field>
                                        <v-time-picker
                                            v-if="menuPicker4"
                                            format="24hr"
                                            v-model="endTime"
                                            @change="$refs.menuPicker4.save(endTime)"
                                        ></v-time-picker>
                                    </v-menu>
                                </v-flex>
                            </v-layout>
                            <!-- NAPRAVE -->
                            <v-layout row wrap>
                                <v-flex xs12 sm12 md4 lg4>
                                    <v-subheader>Naprava</v-subheader>
                                </v-flex>
                                <v-flex xs12 sm12 md8 lg8>
                                    <v-select
                                        v-model="selectedDevices"
                                        :items="devices"
                                        label="Izberi napravo"
                                        multiple
                                        chips
                                        clearable
                                        deletable-chips
                                        prepend-icon="dvr"
                                        item-value="id"
                                        item-text="name"
                                        return-object
                                        dense
                                        no-data-text="Ni podatkov za prikaz"
                                    ></v-select>
                                </v-flex>
                            </v-layout>
                            <!-- TIPI DOGODKOV -->
                            <v-layout row wrap>
                                <v-flex xs12 sm12 md4 lg4>
                                    <v-subheader>Tip dogodka</v-subheader>
                                </v-flex>
                                <v-flex xs12 sm12 md8 lg8>
                                    <v-select
                                        v-model="selectedEventTypes"
                                        :items="eventTypes"
                                        label="Izberi tip dogodka"
                                        multiple
                                        chips
                                        clearable
                                        deletable-chips
                                        prepend-icon="bookmarks"
                                        item-value="id"
                                        item-text="name"
                                        return-object
                                        dense
                                        no-data-text="Ni podatkov za prikaz"
                                    ></v-select>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex xs12 sm12 md4 lg4>
                                    <v-subheader>ID kartice</v-subheader>
                                </v-flex>
                                <v-flex xs12 sm12 md8 lg8>
                                    <v-text-field
                                    v-model="cardId"
                                    label="Vpiši ID kartice"
                                    prepend-icon="create"
                                    @keyup.esc="clearCardId"
                                    @keyup.enter="getResults"
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                            <!-- REGISTRKA ŠT. VOZILA -->
                            <v-layout row wrap>
                                <v-flex xs12 sm12 md4 lg4>
                                    <v-subheader>Registrska številka</v-subheader>
                                </v-flex>
                                <v-flex xs12 sm12 md8 lg8>
                                    <v-text-field
                                    v-model="registrationNumber"
                                    label="Vpiši registrsko številko vozila"
                                    prepend-icon="create"
                                    @keyup.esc="clearRegistrationNumber"
                                    @keyup.enter="getResults"
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions class="pa-4" v-show="showDataTableFilters">
                            <!--<v-spacer></v-spacer>-->
                            <div>
                                <v-btn dark :block="$vuetify.breakpoint.xsOnly" class="elevation-1" color="indigo " @click="getResults"><v-icon left>list</v-icon>Prikaz rezultatov</v-btn> 
                            </div>
                        </v-card-actions>
                    </v-card>
                </v-flex>
            </v-layout>
            <data-table
            :settings="dataTableSettings"
            :queryParameters="queryParameters"
            ></data-table>
        </v-container>
    </div>
</template>

<script>
import DataTable from '@/components/DataTable.vue'
import { EventBus } from '@/main.js'
import { getCurrentDate, getCurrentTime, formatDate } from '@/helpers/utilities'

export default {
    components: {
        DataTable
    },
    data: () => ({
        showDataTableFilters: true,
        blockedUsers: false,
        scanBtn: true,
        scanNr: null,
        form: true,
        dataTableSettings: {
            title: 'Seznam dogodkov',
            sortColumn: 'event_timestamp',
            sortDirection: 'desc',
            headers: [
                { text: "Uporabnik", value: "user_name", class: "text-xs-left", visibility: true },
                { text: "Naziv naprave", value: "device_name", class: "text-xs-left", visibility: true },
                { text: "Registrska številka", value: "registration_plate_number", class: "text-xs-left", visibility: true },
                { text: "ID kartice", value: "card_id", class: "text-xs-left", visibility: true },
                { text: "Št. kartice", value: "card_number", class: "text-xs-left", visibility: true },
                { text: "Naziv dogodka", value: "event_name", class: "text-xs-left", visibility: true },
                { text: "Čas dogodka", value: "event_timestamp", class: "text-xs-right", visibility: true }

            ],
            updateInterval: false,
            rowsPerPage: 10,
            endpoint: "supernova/events",
            editItem: {
                route: "edit-user"
            },

            toolbar: {
                buttons: {
                    refresh: true,
                    export: false,
                    addNew: false,
                    addNewRoute: null
                }
            },

            eventBus: {
                refreshDataTable: 'supernovaEvents',
                totalItems : {
                    event: ''
                },
                search: 'supernova-events-nrSearch'
            }
        },

        menuPicker1: false,
        startDate: null,
        startDateFormatted: null,

        menuPicker2: false,
        endDate: null,
        endDateFormatted: null,

        menuPicker3: false,
        startTime: null,

        menuPicker4: false,
        endTime: null,
        cardId: null,
        registrationNumber: null,

        totalItems: 0,

        devices: [],
        eventTypes: [],
        selectedDevices: [],
        selectedEventTypes: []
    }),

    watch: {
        startDate: {
            handler(newValue, oldValue) {
                this.startDateFormatted = formatDate(this.startDate)
            }
        },

        endDate: {
            handler(newValue, oldValue) {
                this.endDateFormatted = formatDate(this.endDate)
                //this.$store.commit('permits/updateTrafficPillarsEndDate', newValue)
            }
        }
    },

    computed: {
        filterToolbarColor() {
            return (this.showDataTableFilters) ? 'transparent' : 'transparent'
        },

        queryParameters() {
            return {
                startDate: this.startDate,
                endDate: this.endDate,
                startTime: this.startTime,
                endTime: this.endTime,
                cardId: this.cardId,
                registrationNumber: this.registrationNumber,
                selectedDevices: this.selectedDevices.map(item => item.id),
                selectedEventTypes: this.selectedEventTypes.map(item => item.id)
            }
        },

        checkboxBlockedCardsOnlyLabel() {
            if(this.blockedUsers) {
                return "DA"
            }

            return "NE"
        },

        displayScanNrInput() {
            if(!this.scanBtn) {
                return true
            }

            return false
        }
    },

    methods: {
        startDateMenuSave(value) {
            this.$refs.menuPicker1.save(value)
            this.menuPicker1 = false
        },

        endDateMenuSave(value) {
            this.$refs.menuPicker2.save(value)
            this.menuPicker2 = false
        },
        
        getResults() {
            EventBus.$emit(this.dataTableSettings.eventBus.refreshDataTable, 'pass-some-data');
            //console.log(this.queryParameters)
        },

         displayResults() {
            setTimeout(() => {
                EventBus.$emit(this.dataTableSettings.eventBus.refreshDataTable, 'pass-some-data');
            }, 250)
        },

        clickToScan() {
            this.scanBtn = false
            this.setFocus()
            var vm = this
            setTimeout ( () => {
                vm.scanBtn = true
            }, 15000)
        },

        setFocus() {
            if(!this.scanBtn) {
                var vm = this
                setTimeout(() => {
                    vm.$refs.scan_input.focus()
                }, 250)
            }
        },

        scanCard() {
            var vm = this
            vm.$store.commit('SET_PROGRESS', true)
            this.$store.dispatch('RFID_NR_SEARCH', this.scanNr)
            .then(response => {
                //console.log(response)
                //console.log("dsfsdfsdf")
                //console.log(response.data.rfidNr)
                EventBus.$emit(this.dataTableSettings.eventBus.search, response.data.rfidNr.toString());
                this.scanNr = null
                this.scanBtn = true
                vm.$store.commit('SET_PROGRESS', false)
            })
            .catch(error => {
                this.scanNr = null
                this.scanBtn = true
                vm.$store.commit('SET_PROGRESS', false)
                vm.$store.commit('snackbarDisplay', true)
                vm.$store.commit('snackbarMode', 'multi-line')
                vm.$store.commit('snackbarText', 'Pri skeniranju kartice je prišlo do napake. Prosimo poskusite ponovno.')
                vm.$store.commit('snackbarDisplay', true)
            })
        },

        setParametersData() {
            var vm = this
            vm.$store.commit('SET_PROGRESS', true)
            vm.$store.dispatch('PARAMETERS_DATA')
            .then(response => {
                //console.log(response)
                //console.log(response.data)
                this.eventTypes = response.data.eventTypes
                this.devices = response.data.devices
            })
            .catch(error => {
                console.error("### setParametersData ###");
                console.log(error)
            })
            .finally(() => {
                vm.$store.commit('SET_PROGRESS', false)  
            })
        },

        clearCardId() {
            this.cardId = null
        },

        clearRegistrationNumber() {
            this.registrationNumber = null
        }
    },

    created() {
        this.$store.dispatch('ROUTE_NAME', this.$route.name) 
        this.setParametersData()
        this.startDate = getCurrentDate()
        this.endDate = getCurrentDate()
        this.startTime = "00:01"
        //this.endTime = getCurrentTime()
        this.endTime = "23:59";
    },

    mounted() {

    },

    destroyed() {

    }
}
</script>

<style>
    @media all and (max-width: 600px) {
        .v-chip__content {
            height:auto !important;
            white-space:normal !important;
            margin:5px 5px 5px 5px !important;
        }
    }
</style>




